import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import moment from 'moment';
import 'moment/locale/pt-br';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { formatarDocumento } from '../../Utils/documentoAlfanumerico';
import { getRelacionamentosCrm } from '../../../api/relacionamentos';

const NovoRelacionamento = ({
  setDadosModalDashboardRelacionamentos,
  atualizarDashboard
}) => {
  const [dadosUltimoRelacionamento, setDadosUltimoRelacionamento] =
    useState(false);
  const [dadosLead, setDadosLead] = useState(false);
  const msgVazio = 'Não informado';

  useEffect(() => {
    getRelacionamentosCrm('novo_relacionamento')
      .then(res => {
        setDadosLead(res.data);
        const first = [...res.data].shift();
        setDadosUltimoRelacionamento(first);
      })
      .catch(() => {})
      .finally(() => {});
  }, [atualizarDashboard]);

  const mostrarModalDashBoard = value => {
    const dados = {};
    if (value === 'todos') {
      dados.titleModal = 'Novo(s) relacionamentos(s)';
      dados.grid = dadosLead;
    } else {
      dados.titleModal = 'Cadastro';
      dados.verCadastro = dadosUltimoRelacionamento;
    }
    setDadosModalDashboardRelacionamentos(dados);
  };

  return (
    <Box className="card-novo-lead">
      <Box sx={{ display: 'flex' }}>
        <Box className="ultimos-lead-info w-100 margin-bottom-5">
          <InfoOutlinedIcon />
          <Typography
            className="texto-cor-principal font-bold-600"
            variant="h7"
          >
            Novo Relacionamento
          </Typography>
        </Box>
        <Box className="w-100">
          {dadosLead && dadosLead.length > 0 && (
            <Typography
              className="link-ver-todos"
              variant="h7"
              onClick={() => mostrarModalDashBoard('todos')}
            >
              Ver todos
            </Typography>
          )}
        </Box>
      </Box>

      {dadosUltimoRelacionamento ? (
        <Box
          className="box-cliente-lead texto-nao-selecionavel"
          onClick={() => mostrarModalDashBoard('ultimo')}
        >
          <Box className="width-box">
            <Typography
              className="text-overflow-ellipsis texto-centro"
              variant="h7"
              sx={{ minWidth: '14%' }}
            >
              {formatarDocumento(String(dadosUltimoRelacionamento.cpf_cnpj))}
            </Typography>

            <Typography
              className="text-overflow-ellipsis texto-centro"
              variant="h7"
              sx={{ minWidth: '15%' }}
            >
              {dadosUltimoRelacionamento.nome ?? msgVazio}
            </Typography>

            <Typography
              className="text-overflow-ellipsis texto-centro"
              variant="h7"
              sx={{ minWidth: '15%' }}
            >
              {dadosUltimoRelacionamento.email ?? msgVazio}
            </Typography>

            <Typography
              className="text-overflow-ellipsis texto-centro"
              variant="h7"
              sx={{ minWidth: '11%' }}
            >
              {dadosUltimoRelacionamento.telefone ?? msgVazio}
            </Typography>

            <Typography
              className="text-overflow-ellipsis texto-centro"
              variant="h7"
              sx={{ minWidth: '11%' }}
            >
              {dadosUltimoRelacionamento.whatsapp ?? msgVazio}
            </Typography>

            <Typography
              className="text-overflow-ellipsis texto-centro flex-box-items-centralizados items-centralizados"
              variant="h7"
              sx={{ minWidth: '11%' }}
              title={moment(dadosUltimoRelacionamento.data_insert).format(
                'DD/MM/yyyy HH:mm:ss'
              )}
            >
              <AccessTimeIcon className="font-size-18 margin-right-3" />
              {moment(dadosUltimoRelacionamento.data_insert).local().fromNow()}
            </Typography>

            <Typography
              className="text-overflow-ellipsis texto-centro"
              variant="h7"
              sx={{ minWidth: '5%' }}
            >
              {dadosUltimoRelacionamento.nome_usuario_reserva}
            </Typography>
          </Box>
        </Box>
      ) : (
        <Box className="box-cliente-lead">
          <Box className="width-box">
            <Box>Nenhum relacionamento encontrado</Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default NovoRelacionamento;
